import { Router } from '@angular/router';
import { AuthTokenService } from '../../core/services/auth-token.service';

export function navigateAfterAuth(router: Router, authTokenService: AuthTokenService): void {
  const redirectUrl = authTokenService.getRedirectUrl();
  authTokenService.clearRedirectUrl(); // Optional: prevent repeated redirects
  router.navigateByUrl(redirectUrl || '/meal-planner');
}
